<template>
  <a
    :id="uid"
    data-samora
    :class="linkClasses"
    :href="href"
    :target="newTab ? '_blank' : '_self'"
    v-on="disabled ? {} : $listeners"
  >
    <slot />
    <SamTooltip
      v-if="hasTooltip && !disabled"
      data-testid="samLinkTooltip"
      :message="tooltip"
      position="top"
      :anchor-name="uid"
    >
    </SamTooltip>
  </a>
</template>

<script>
import SamTooltip from '../SamTooltip/SamTooltip.vue';
import { uuidv4 } from '../../../utils/utils';

export default {
  name: 'SamLink',
  components: { SamTooltip },
  props: {
    /**
     * The link's id
     */
    id: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * The link's href
     */
    href: {
      type: String,
      required: false,
      // https://stackoverflow.com/questions/8260546/make-a-html-link-that-does-nothing-literally-nothing
      // eslint-disable-next-line no-script-url
      default: 'javascript:void(0)',
    },
    /**
     * If the link should open on new tab
     * @values true, false
     */
    newTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Puts the link on a disabled state
     * @values true, false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * This link's tooltip
     */
    tooltip: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    uid() {
      return this.id || `link__${uuidv4()}`;
    },
    linkClasses() {
      return {
        'sam-link': true,
        'is-disabled': this.disabled,
      };
    },
    hasTooltip() {
      return !!this.tooltip;
    },
  },
};
</script>

<style scoped lang="scss">
.sam-link {
  position: relative;
  font-family: inherit;
  font-weight: 500;
  font-size: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  color: $informative--main;
  transition: color 0.2s;

  &:hover {
    color: $informative--hover;
  }

  &.is-disabled {
    color: $neutral--60;
    pointer-events: none;
  }
}
</style>
